// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { lastDayOfISOWeekYear as fn } from "../lastDayOfISOWeekYear.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const lastDayOfISOWeekYearWithOptions = convertToFP(fn, 2);

// Fallback for modularized imports:
export default lastDayOfISOWeekYearWithOptions;
